export const MODULE_NAME = 'PurchaseOrdersReport';
